import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const ContactPage = ({ location }) => (
  <Layout>
    <SEO title="Contact" currentUrl={location.pathname} />
    <div className={"container"}>
      <div className={"content"}>
        <div className={"title"}>
          <h1>Contact</h1>
        </div>

        <div className={"row"}>
          <div className={"col-7"}>
            <p>
              If you have any questions about McPiper feel free to get in touch,
              either via email or twitter.
            </p>
          </div>

          <div className={"col-5"}>
            <div className={"contact-items"}>
              <p>Plain email is the best way to contact me.</p>
              <h2>
                <a href="mailto:hi.mcpiper@oleggera.com">
                  hi.mcpiper@oleggera.com
                </a>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default ContactPage
